__turbopack_context__.v({
  "copy": "-_cu5W_copy",
  "headline": "-_cu5W_headline",
  "intro": "-_cu5W_intro",
  "logo": "-_cu5W_logo",
  "nestedWrapper": "-_cu5W_nestedWrapper",
  "overline": "-_cu5W_overline",
  "text": "-_cu5W_text",
  "wrapper": "-_cu5W_wrapper",
});
